import React from "react";
import R14, {
  View,
  StyleSheet,
  Image,
  Text,
} from "../core";
import Touchable from "./TouchableComponent";
import { commonStyles } from "../assets/css/commonStyle";
import { commonFontStyles } from "../assets/css/commonFontStyles";
import filterIcon from "../assets/images/NewFilterIcon.png";
import closeIcon from "../assets/images/closeIcon.png";
import arrowLeft from "../assets/images/arrowleft.png";
import arrowRight from "../assets/images/arrowright.png";

export default R14.connect(
  class SortDataTableComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isSortOpen: false,
        filter: {},
        sortDirection: '' //ASC or DESC
      };
    }

    sortToggle = async () => {
      this.setState({
        isSortOpen: !this.state.isSortOpen,
      });
    };

    onSort = async (filter, sortDirection) => {
      this.props.app.dm.userSession.setState({ isLoading: true });
      await this.props.getPageData({sortColumnName: filter.value, sortDirection });
      this.setState({
        isSortOpen: false,
        filter,
        sortDirection
      });
      return false
    }

    renderSortSection = () => {
      const {isSortOpen, filter, sortDirection} = this.state;
      const {sortingFields} = this.props;
      return (
        <View style={[!isSortOpen && commonStyles.displayNone, styles.sortSection ]}>
          <View style={[styles.sortContainer]}>
            <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, commonStyles.alignItemsCenter, commonStyles.justifyContentSpaceBetween]}>
              <Text style={[commonFontStyles.workSans, commonStyles.smallHeading, commonStyles.fontWeight500, commonStyles.wordBreakWord]}>{"Sort"}</Text>
              <Touchable onPress={() => this.sortToggle()}>
                <Image source={closeIcon} style={commonStyles.icon12} />
              </Touchable>
            </View>
            {sortingFields && sortingFields.length &&  sortingFields.map( sort => (
              <View style={[commonStyles.flex1, commonStyles.flexDirectionRow, commonStyles.alignItemsCenter, commonStyles.justifyContentSpaceBetween, commonStyles.paddingTopBottom5]}>
                <Text style={[commonFontStyles.workSans, commonStyles.exSmallHeading, commonStyles.fontWeight400, commonStyles.wordBreakWord]}>{sort.key}</Text>
                <Touchable style={[sort.value === filter.value && sortDirection === "ASC" ? styles.activeBgColor : null ]} onPress={() => this.onSort(sort, 'ASC')}>
                  <Image source={arrowLeft} style={commonStyles.icon12}/>
                </Touchable>
                <Touchable style={[sort.value === filter.value && sortDirection === "DESC" ? styles.activeBgColor : null ]} onPress={() => this.onSort(sort, 'DESC')}>
                  <Image source={arrowRight} style={commonStyles.icon12}/>
                </Touchable>
              </View>
            ))}
          </View>
        </View>
      );
    };

    render() {
      if(!!this.props.app.dm.userSession.state.isUberDocs) return null;
      return (
        <>
          <Touchable onPress={() => this.sortToggle()} style={[styles.marginLtRt8]}>
            <Image source={filterIcon} style={commonStyles.icon18} />
          </Touchable>
          {this.renderSortSection()}
        </>
      );
    }
  }
);

const styles = StyleSheet.create({
  searchContainer: {
    position: "absolute",
    zIndex: 1,
    marginRight: 65,
    marginTop: -10,
  },
  marginLtRt8: {
    marginLeft: 8,
    marginRight: 16,
  },
  sortSection: {
    position: "absolute",
    marginTop: 24,
    marginRight: 80,
    zIndex: 1,
  },
  sortContainer: {
    width: 150,
    height: 'fit-content',
    backgroundColor: "#fff",
    padding: 10,
    borderColor: "#e4e4e4",
    borderWidth: 1,
    borderStyle: "solid"
  },
  activeBgColor: {
    backgroundColor: "#1277d9",
  }
});
